import { PrinterOutlined } from '@ant-design/icons';
import { Button, Checkbox, ConfigProvider, Divider, Form, Row, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { hooks, models } from '@vote4dance/judging-sdk';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
var Stream = hooks.streams.Stream;
var RoundItem = models.rounds.RoundItem;
var ClassRoundSource = models.rounds.ClassRoundSource;
var ClassItemSource = models.classes.ClassItemSource;
import { PrintStartNumberHeader } from '../../teams/components/PrintStartNumber';
import { ClassJudgeList, RoundResult } from '../../../../../base-react/components/Results';
import { Loading } from '../../../../../base-react/components/Loading';
const { Title } = Typography;
export const PrintResult = () => {
    var _a;
    const { competition_id, class_id, round_id } = useParams();
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    const [classItem, loadingClassItem] = Stream(ClassItemSource(competition_id, class_id));
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const [settings, setSettings] = useState({
        showMajority: true
    });
    if (loadingRounds || loadingClassItem || loadingCompetition) {
        return React.createElement(Loading, null);
    }
    const foundRound = rounds && rounds.find((a) => a.round_id === round_id);
    if (!foundRound) {
        return null;
    }
    document.title = `${event === null || event === void 0 ? void 0 : event.competition_date}_${event === null || event === void 0 ? void 0 : event.competition_name}_${foundRound.class_name}_${foundRound.round_label}_result`;
    const sharedPanelId = (_a = foundRound.panel_id) !== null && _a !== void 0 ? _a : classItem === null || classItem === void 0 ? void 0 : classItem.default_panel_id;
    return (React.createElement(ConfigProvider, null,
        React.createElement("style", { type: "text/css", media: "print" }, ` @page { size: ${settings.showMajority ? 'landscape' : 'portrait'}; margin: 0 !important } `),
        React.createElement(PrintResultSettings, { settings: settings, setSettings: setSettings }),
        React.createElement("div", { style: { margin: 24 } },
            React.createElement(PrintStartNumberHeader, { event: event, competition: inputCompetition, style: { height: 'inherit' } }),
            React.createElement(Title, { level: 2 },
                React.createElement(Space, { wrap: true, separator: React.createElement(Divider, { orientation: 'vertical' }), size: 'small' }, RoundItem.getClassLabel(foundRound))),
            React.createElement(RoundResult, { competition_id: competition_id, class_id: class_id, round_id: round_id, settings: settings, sharedPanelId: sharedPanelId }),
            sharedPanelId && (React.createElement("div", { style: { width: '100%', marginTop: 16 } },
                React.createElement(ClassJudgeList, { competition_id: competition_id, panel_id: sharedPanelId }))))));
};
const PrintResultSettings = (props) => {
    const { settings, setSettings } = props;
    const onValuesChange = (values) => {
        setSettings({
            ...settings,
            ...values
        });
    };
    const onFinish = () => {
        window.print();
    };
    return (React.createElement(Row, { style: { width: '100%', paddingLeft: 30, backgroundColor: 'lightgrey' } },
        React.createElement("div", { className: "settings" },
            React.createElement("style", null, `@media print {.settings{display: none;}}`),
            React.createElement(Title, null, _T('common.print', { name: _T('round.heat').toLowerCase() })),
            React.createElement(Form, { name: "printsettings", labelCol: { span: 8 }, wrapperCol: { span: 16 }, style: { maxWidth: 600 }, initialValues: settings, onValuesChange: onValuesChange, onFinish: onFinish, autoComplete: "off" },
                React.createElement(Form.Item, { name: "showMajority", valuePropName: "checked", style: { marginBottom: 0 } },
                    React.createElement(Checkbox, null, _T('print.showMajority'))),
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null), type: "primary", htmlType: "submit" }, _T('common.print')))))));
};
